<template>
  <div>
    <a-list itemLayout="horizontal" :dataSource="data">
      <a-list-item slot="renderItem" slot-scope="item, index" :key="index">
        <a-list-item-meta>
          <a slot="title">{{ item.title }}</a>
          <span slot="description">
            <span class="security-list-description">{{
              item.description
            }}</span>
            <span v-if="item.value">:</span>
            <span class="security-list-value">{{ item.value }}</span>
          </span>
        </a-list-item-meta>
        <template v-if="item.actions">
          <a slot="actions" @click="item.actions.callback">{{
            item.actions.title
          }}</a>
        </template>
      </a-list-item>
    </a-list>

    <!-- 修改密码 -->
    <password ref="psw"></password>
    <!-- 绑定邮箱，手机号 -->
    <bind-info ref="bind" @success="refresh"></bind-info>
  </div>
</template>

<script>
import Password from "./Password.vue";
import BindInfo from "./BindInfo.vue";
export default {
  name: "SecuritySetting",
  components: {
    Password,
    BindInfo
  },
  data() {
    return {
      userInfo: {},
      data: [
        // { title: '账户密码', description: '当前密码强度', value: '强', actions: { title: '修改', callback: () => { this.$message.info('This is a normal message') } } },
        {
          title: "账户密码",
          description: "",
          value: "",
          actions: {
            title: "修改密码",
            callback: () => {
              this.$refs.psw.show();
            }
          }
        },
        {
          title: "手机",
          description: "已绑定手机",
          value: "",
          actions: {
            title: "",
            callback: () => {
              this.$refs.bind.show("mobile");
            }
          }
        },
        {
          title: "邮箱",
          description: "已绑定邮箱",
          value: "",
          actions: {
            title: "",
            callback: () => {
              this.$refs.bind.show("email");
            }
          }
        }
        // { title: 'MFA 设备', description: '未绑定 MFA 设备，绑定后，可以进行二次确认', value: '', actions: { title: '绑定', callback: () => { this.$message.info('This is a normal message') } } }
      ]
    };
  },
  created() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.userInfo = this.$store.getters.userInfo;
      if (this.userInfo.mobile) {
        const reg = /(\d{3})\d{4}(\d{4})/;
        let mobile = this.userInfo.mobile;
        this.data[1].value = mobile.replace(reg, "$1****$2");
        this.data[1].actions.title = "重新绑定";
      } else {
        this.data[1].description = "未绑定手机号";
        this.data[1].actions.title = "绑定";
      }
      if (this.userInfo.email) {
        const reg = /(.{2}).+(.{2}@.+)/g;
        let email = this.userInfo.email;
        this.data[2].value = email.replace(reg, "$1****$2");
        this.data[2].actions.title = "重新绑定";
      } else {
        this.data[2].description = "未绑定邮箱";
        this.data[2].actions.title = "绑定";
      }
    }
  }
};
</script>

<style scoped></style>
